//import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
//import { useStrings } from '../i18n';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { isAuthenticated, loadingUser, userInfo } = useAuth();
  const location = useLocation();
  //const strings = useStrings();

  if (loadingUser) {
    // Optionally show a loading spinner or null while auth is loading
    return null;
  }

  if (!isAuthenticated) {
    // Pass current path as state.from so Login can redirect back after sign-in
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Check if admin-only route and user is admin
  if (adminOnly && userInfo?.role !== 'admin' && userInfo?.role !== 'superadmin') {
    // user is not admin
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
